<template>
  <accept-modal
    v-if="showAcceptModal"
    v-on:accept="showAcceptModal = false"
    :title="$t('explorer.urlCopy')">
  </accept-modal>
</template>

<script>
import AcceptModal from '@/components/shared/dialogs/AcceptModal';

export default {
  name: 'CopyUrlModal',
  components: {
    AcceptModal
  },
  data () {
    return {
      showAcceptModal: false
    };
  },
  methods: {
    show () {
      this.copyUrl();
      this.showAcceptModal = true;
    },
    copyUrl () {
      // Hacky way to copy URL to clipboard
      const dummy = document.createElement('input');
      const text = window.location.href;
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/explorer/CopyUrlModal.vue